import styled from 'styled-components/macro'
import Box from 'components/shared/Box'
import desktopDecor from 'assets/images/decors/winterBreakAside_desktop.svg'
import mobileDecor from 'assets/images/decors/winterBreakAside_mobile.svg'
import { respondAbove } from 'styles/mediaQueries'

export const WinterBreakAttractionsAsideInfoWrapper = styled(Box)`
    position: relative;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    width: 100%;
    background-image: url(${mobileDecor});
    background-color: ${({ theme }) => theme.colors.grayscale_400};
    background-position: center top;
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: 8px;

    @media ${respondAbove.xl} {
        position: sticky;
        top: 24px;
        margin-bottom: 244px;
        background-image: url(${desktopDecor});
    }
`
